import { ToastProvider } from "./services/contexts/Toast";
import AppNavigation from "./services/contexts/Auth";

function App() {
  return (
    <>
      <ToastProvider>
        <AppNavigation />
      </ToastProvider>
    </>
  );
}

export default App;
